module.exports = __webpack_public_path__ + "img/calendar-solid.47a8879d.svg";